import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { TabHeader, Tab } from '../../atoms/TabHeader';
import { Container, Layout, Layouts } from './styles';

export const TabbedLayout = ({ tabPages, className }: TabbedLayoutProps) => {
  const tabs = useMemo<Tab[]>(
    () =>
      tabPages.map((tabPage) => ({ key: tabPage.key, label: tabPage.label })),
    [tabPages],
  );

  const [activeTabKey, setActiveTabKey] = useState<string | undefined>(
    tabPages.length ? tabPages[0].key : undefined,
  );

  useEffect(() => {
    if (
      tabPages.length &&
      !tabPages.some((page) => page.key === activeTabKey)
    ) {
      setActiveTabKey(tabPages[0].key);
    }
  }, [tabPages, activeTabKey]);

  const activeTab = tabs.find((tab) => tab.key === activeTabKey);

  return (
    <Container className={className}>
      <TabHeader
        items={tabs}
        selectedTab={activeTab}
        onSelect={(tab) => setActiveTabKey(tab.key)}
      />
      <Layouts className="tabPages">
        {tabPages.map((tabPage) => (
          <Layout
            key={tabPage.key}
            $active={activeTab?.key === tabPage.key}
            className="tabPage"
          >
            {tabPage.component}
          </Layout>
        ))}
      </Layouts>
    </Container>
  );
};

export interface TabbedLayoutProps {
  tabPages: TabPage[];
  className?: string;
}

export interface TabPage {
  key: string;
  label: string | ReactElement;
  component: ReactElement;
}
